<script lang="ts" setup>
// defineProps with a comments prop that accepts a type of string[]
const { comments } = defineProps({
  comments: {
    type: Array as PropType<string[]>,
    required: true,
  },
});

const {} = defineEmits(["selected"]);

const container = ref<HTMLElement | undefined>(undefined);
const indicator = ref(null);

const displayIndicator = ref(false);

const checkScrollIndicator = () => {
  if (!container.value) {
    return;
  }

  const isScrollable =
    container.value?.scrollHeight > container.value?.clientHeight;
  const isScrolledToBottom =
    container.value?.scrollHeight - container.value?.scrollTop ===
    container.value?.clientHeight;

  if (isScrollable && !isScrolledToBottom) {
    displayIndicator.value = true;
  } else {
    displayIndicator.value = false;
  }
};

onMounted(() => {
  checkScrollIndicator();
  container.value?.addEventListener("scroll", checkScrollIndicator);
});

onBeforeUnmount(() => {
  container.value?.removeEventListener("scroll", checkScrollIndicator);
});
</script>

<template>
  <div class="h-[20%] relative" id="scroll-container">
    <div class="h-full overflow-y-auto px-1" ref="container">
      <div
        v-for="(comment, key) in comments"
        :key="key"
        class="bg-surface rounded shadow p-2 cursor-pointer my-2 hover:bg-light-tint text-[14px]"
        @click.prevent.stop="$emit('selected', comment)"
      >
        {{ comment }}
      </div>
    </div>
    <div
      ref="indicator"
      id="scroll-indicator"
      class="absolute bottom-0 left-0 right-0 h-[40px] transition-opacity pointer-events-none"
      :style="{
        background:
          'linear-gradient(to top, rgba(0,0,0,0.1), rgba(0,0,0,0) 80%)',
      }"
      :class="{
        ' opacity-100': displayIndicator,
        ' opacity-0': !displayIndicator,
      }"
    ></div>
  </div>
</template>

<style scoped></style>
